import React from 'react';
import {IS_SEPARATED, ROOT_PATH, TRACK_PATH} from "@constants/config";
import {Box, Typography} from '@mui/material';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

const HomeLinkBreadcrumb = () => {

    const {t} = useTranslation()

    if (!IS_SEPARATED) {
        return (
            <Box component={'a'} href={`${TRACK_PATH}/dashboard`}>
                <Typography
                    sx={{fontWeight: '700'}}
                    variant={'body2'}
                    color="text.primary">
                    {t('base.home')}
                </Typography>
            </Box>
        )
    }
    return (
        <Link
            to={ROOT_PATH}
        >
            <Typography
                sx={{fontWeight: '700'}}
                variant={'body2'}
                color="text.primary"
            >
                {t('base.home')}
            </Typography>
        </Link>
    );
};

export default HomeLinkBreadcrumb;